const desktopProductCards = window.matchMedia('(min-width: 750px)');

const productCardLinkSelector = [
  'a.vmax-online-product[href*="/products/"]',
  'product-card a[href*="/products/"]',
  '.resource-card[data-resource-type="product"] a[href*="/products/"]',
  '.vmax-new-drops-card a[href*="/products/"]',
  '[data-vmax-product-id][href*="/products/"]',
].join(',');

const updateProductCardLinks = (scope = document) => {
  const links = [];

  if (scope instanceof Element && scope.matches(productCardLinkSelector)) {
    links.push(scope);
  }

  if (scope instanceof Document || scope instanceof DocumentFragment || scope instanceof Element) {
    links.push(...scope.querySelectorAll(productCardLinkSelector));
  }

  links.forEach((link) => {
    if (!(link instanceof HTMLAnchorElement)) return;

    if (desktopProductCards.matches) {
      if (!link.hasAttribute('data-vmax-original-target')) {
        link.dataset.vmaxOriginalTarget = link.getAttribute('target') || '';
      }
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.dataset.vmaxDesktopNewTab = 'true';
      return;
    }

    if (link.dataset.vmaxDesktopNewTab !== 'true') return;

    const originalTarget = link.dataset.vmaxOriginalTarget || '';
    if (originalTarget) {
      link.target = originalTarget;
    } else {
      link.removeAttribute('target');
    }
    link.removeAttribute('data-vmax-desktop-new-tab');
    link.removeAttribute('data-vmax-original-target');
  });
};

updateProductCardLinks();
desktopProductCards.addEventListener('change', () => updateProductCardLinks());

const productCardObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element || node instanceof DocumentFragment) {
        updateProductCardLinks(node);
      }
    });
  });
});

productCardObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
});
